import { render, staticRenderFns } from "./ConsultaClienteCredito.vue?vue&type=template&id=18838914"
import script from "./ConsultaClienteCredito.vue?vue&type=script&lang=js"
export * from "./ConsultaClienteCredito.vue?vue&type=script&lang=js"
import style0 from "./ConsultaClienteCredito.vue?vue&type=style&index=0&id=18838914&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports